interface LavaOrbProps {
  size?: string;
}

export default function LavaOrb({ size = 'h-5 w-5' }: LavaOrbProps) {
  return (
    <img
      src="/logo-orb.png"
      alt=""
      aria-hidden="true"
      className={`${size} rounded-full object-cover`}
    />
  );
}
